<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    :max-width="`${width}px`"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon flat @click="$emit('cancel')">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :dark="!sameInput" :disabled="sameInput" @click="submit">
          <v-icon>save</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 1000px">
        <v-form>
          <v-text-field
            v-if="dialog"
            autofocus
            append-icon="chrome_reader_mode"
            type="text"
            v-model="input.materi"
            v-validate="'required'"
            name="materi"
            data-vv-name="materi"
            label="Judul Materi"
            data-vv-as="Judul Materi"
            :error-messages="errors.collect('materi')"
          >
          </v-text-field>
          <v-textarea
            auto-grow
            :rows="1"
            counter
            append-icon="toc"
            type="text"
            v-model="input.tujuan"
            v-validate="'required'"
            name="tujuan"
            data-vv-name="tujuan"
            label="Tujuan"
            data-vv-as="Tujuan"
            :error-messages="errors.collect('tujuan')"
          >
          </v-textarea>
          <v-text-field
            append-icon="turned_in_not"
            type="text"
            v-model="input.kompetensi"
            v-validate="''"
            name="kompetensi"
            data-vv-name="kompetensi"
            label="Kompetensi"
            data-vv-as="Kompetensi"
            :error-messages="errors.collect('kompetensi')"
          >
          </v-text-field>
          <v-select
            append-icon="local_offer"
            attach
            item-text="laman"
            item-value="id_laman"
            :items="lamanByLaman"
            v-model="input.id_laman"
            v-validate="'required'"
            name="id_laman"
            data-vv-name="id_laman"
            label="Business Unit"
            data-vv-as="Business Unit"
            :error-messages="errors.collect('id_laman')"
          >
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item.laman }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.laman_desc
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-select>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

const defaultInput = {
  materi: "",
  tujuan: "",
  kompetensi: "",
  id_laman: "",
  id_user: ""
};

export default {
  name: "materi-input",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data() {
    return {
      input: _.cloneDeep(defaultInput),
      dataInjected: null
    };
  },
  computed: {
    ...mapState(["status", "id_laman$"]),
    ...mapState("auth", ["profil"]),
    ...mapGetters("laman", ["lamanByLaman"]),
    ...mapGetters("area", ["areaByLaman"]),
    source() {
      return this.$store.state[this.primary_field][this.primary_field];
    },
    titleDialog() {
      let title = this.action == "ADD" ? "TAMBAH" : "EDIT";
      return `${title} ${this.title}`;
    },
    sameInput() {
      return _.isEqual(this.input, this.dataInjected);
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(noError => {
        if (noError) {
          this.$store
            .dispatch(
              `${this.primary_field}/${this.action}_${this.title}`,
              this.input
            )
            .then(() => {
              let new_id =
                this.action == "ADD"
                  ? _.last(this.source)[this.primary_key]
                  : null;
              this.$emit("submitted", new_id);
            })
            .catch();
        } else {
          this.$store.commit(
            "ERROR",
            "Ada field yang masih error, cek kembali isian form!"
          );
        }
      });
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$validator.reset();
        if (this.action == "ADD") {
          this.dataInjected = _.cloneDeep(defaultInput);
          this.dataInjected.id_laman = this.id_laman$;
          this.dataInjected.id_user = this.profil.id_user;
        } else {
          this.dataInjected = _.cloneDeep(this.data);
        }
        this.input = _.cloneDeep(this.dataInjected);
      }
    }
  },
  mounted() {
    this.$store.dispatch("materi/GET_MATERI");
    this.$store.dispatch("materi/GET_OPTIONS");
    this.$store.dispatch("user/GET_USER");
  }
};
</script>
